import { atom } from 'jotai';

export interface IAlertAtomProps {
  open: boolean;
  message: string;
  title: string;
  confirmBtnLabel?: string;
}

export const alertAtom = atom<IAlertAtomProps | null>(null);
